import React from "react";
import {
  Box,
  Typography,
  Menu,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";

const NotificationMenu = ({
  anchorEl,
  notifications,
  onClose,
  navigate,
}) => {
  const handleNotificationClick = (notification) => {
    const path =
      notification.type === "work_order"
        ? `/home/workorders/${notification.id}`
        : notification.type === "violation"
        ? `/home/violations/${notification.id}`
        : "/home"; // Default path, just in case
    navigate(path);
    onClose();
  };

  const handleViewMore = () => {
    navigate("/home/violations");
    onClose();
  };

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <Box sx={{ padding: "16px", maxWidth: "300px" }}>
        <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: 1 }}>
          Notifications
        </Typography>
        {notifications.length > 0 ? (
          notifications.map((notification, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "12px",
                borderBottom: "1px solid #f0f0f0",
                cursor: "pointer",
                "&:hover": { backgroundColor: "#f9f9f9" },
              }}
              onClick={() => handleNotificationClick(notification)}
            >
              <Box
                sx={{
                  marginRight: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "40px",
                  height: "40px",
                  backgroundColor: "#007bff",
                  color: "white",
                  borderRadius: "50%",
                }}
              >
                <NotificationsIcon />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", color: "#333" }}
                >
                  {notification.type === "violation"
                    ? `New Violation: VLT-${notification.id}`
                    : notification.type === "work_order"
                    ? `New Work Order: WO-${notification.id}`
                    : ""}
                </Typography>
                <Typography variant="body2" sx={{ color: "#666", marginTop: "4px" }}>
                  {new Date(notification.date).toLocaleString()}
                </Typography>
              </Box>
            </Box>
          ))
        ) : (
          <Typography
            variant="body2"
            sx={{ textAlign: "center", color: "#999", marginTop: 2 }}
          >
            No new notifications
          </Typography>
        )}
        <Box sx={{ textAlign: "center", marginTop: "12px" }}>
          
        </Box>
      </Box>
    </Menu>
  );
};

export default NotificationMenu;
